import React, { FC } from "react";

import {
  AmountIcon,
  BoardIcon,
  CalendarMiniIcon,
  GraphIcon,
} from "application/assets";
import { useAppSelector } from "application/store";
import { formatTotal } from "application/helpers/formatTotal";

import { IconWrapper, RowStyled, Wrapper } from "./styles";

const InvestmentInfo: FC = () => {
  const { deal } = useAppSelector((state) => state.deal);

  const commitment = deal?.commitmentInfo?.commitment || 0;
  const commitmentTotal = formatTotal(commitment, deal?.dealCurrency);
  const minInvestmentAmount = formatTotal(
    deal?.minInvestmentAmount || 0,
    deal?.dealCurrency
  );
  const multiplier = deal?.multiplier || 0;
  const holdingPeriod = deal?.holdingPeriod || 0;

  return (
    <Wrapper>
      {!!commitment && (
        <RowStyled isUserCommitted={true}>
          <IconWrapper>
            <AmountIcon />
          </IconWrapper>
          <p>You’ve already committed</p>
          <h3>{commitmentTotal}</h3>
        </RowStyled>
      )}
      <RowStyled>
        <IconWrapper>
          <GraphIcon />
        </IconWrapper>
        <p>Min. investment</p>
        <h3>{minInvestmentAmount}</h3>
      </RowStyled>
      <RowStyled>
        <IconWrapper>
          <BoardIcon />
        </IconWrapper>
        <p>Expected Multiplier</p>
        <h3>x {multiplier}</h3>
      </RowStyled>
      {!!holdingPeriod && (
        <RowStyled>
          <IconWrapper>
            <CalendarMiniIcon />
          </IconWrapper>
          <p>Expected holding period</p>
          <h3>
            {holdingPeriod} {`year${holdingPeriod > 1 ? "s" : ""}`}
          </h3>
        </RowStyled>
      )}
    </Wrapper>
  );
};

export default InvestmentInfo;
